import React from "react";
import {
  Backdrop,
  CircularProgress,
  Divider,
  IconButton,
  Table,
  Tooltip,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { useSelector } from "react-redux";
import { GESTIONE_PRATICHE_TABLE_HEADER_USER } from "../../../utils/constants/tables";
import CoreStatus from "../../../app/core/components/CoreStatus/CoreStatus";
import { formatItalianDate } from "../../../utils/functions/date-utils";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import CorePagination from "../../../app/core/components/CorePagination/CorePagination";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";

const GestionePraticheTable = ({
  data,
  page,
  setPage,
  orderDirection,
  setOrderDirection,
  valueToOrderBy,
  setValueToOrderBy,
  isLoading,
  totalPages,
}) => {
  //SELECTION
  const docManagementState = useSelector((state) => state.docManagementSlice);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const navigate = useNavigate();

  const isSelected = (id) =>
    docManagementState.selectedDocsIds.indexOf(id) !== -1;

  const handleRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  return (
    <div className="">
      <TableContainer sx={{ position: "relative" }}>
        <Backdrop
          className="bg-black bg-opacity-30"
          sx={{ position: "absolute", zIndex: 1 }}
          open={isLoading}
        >
          <CircularProgress style={{ color: colorPrimary }} />
        </Backdrop>
        <Table aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              {GESTIONE_PRATICHE_TABLE_HEADER_USER().map((column) => (
                <TableCell
                  key={column.id}
                  align="left"
                  style={{ minWidth: column.minWidth }}
                >
                  <TableSortLabel
                    disabled={
                      column.id === "commercialista" ||
                      column.id === "status" ||
                      column.id === "azioni"
                    }
                    active={valueToOrderBy === column.id}
                    direction={orderDirection}
                    onClick={() => handleRequestSort(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.items?.map((doc) => {
              const isItemSelected = isSelected(doc.id); // Use 'doc.documentId' here
              return (
                <TableRow
                  className="hover:shadow-md"
                  key={doc.id}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  selected={isItemSelected}
                >
                  <TableCell align="left">
                    <div className="flex items-center">
                      {doc.name}
                      {doc.reservationId && (
                        <Tooltip title={t("Reservation")}>
                          <CalendarMonthRoundedIcon
                            className={`fill-blue-700 mx-1 w-5 h-5`}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex flex-col justify-center">
                      <CoreStatus status={doc.status} testo={true} />
                    </div>
                  </TableCell>
                  <TableCell align="left">
                    {formatItalianDate(doc.createdAt)}
                  </TableCell>

                  <TableCell>{doc.commDisplayName || "---"}</TableCell>
                  <TableCell className="items-center" align="left">
                    <div className="flex items-center space-x-2">
                      <Tooltip title={t("Detail")}>
                        <IconButton
                          onClick={() =>
                            navigate(
                              `/auth/user/${t("singlePracticeRoute")}/${doc.id}`
                            )
                          }
                          className="w-10 h-10"
                        >
                          <SearchRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Divider />
        <div className="w-full flex justify-center">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </TableContainer>
    </div>
  );
};

export default GestionePraticheTable;
